<template>
  <div>
    <div class="cabecalho">
      <div class="dias">
        <div
          v-for="(item, indice) in dias"
          v-bind:key="indice"
          class="dia"
          @click="alterarDia(indice)"
        >
          <div class="d-none d-lg-block">
            <div class="indice">DIA {{ item.dia }}</div>
            <div class="nome">{{ item.nome }}</div>
            <div class="borda" v-bind:class="{ ativo: item.estado }"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-lg-none .d-xl-block">
      <carousel v-bind:per-page-custom="[[480, 3]]">
        <slide>
          <b-card @click="alterarDia(0)">
            <div class="indice">DIA 4</div>
            <div class="nome">segunda-feira</div>
            <div
              class="borda-carousel"
              v-bind:class="{ ativo: dias[0].estado }"
            ></div>
          </b-card>
        </slide>
        <slide>
          <b-card @click="alterarDia(1)">
            <div class="indice">DIA 5</div>
            <div class="nome">terça-feira</div>
            <div
              class="borda-carousel"
              v-bind:class="{ ativo: dias[1].estado }"
            ></div>
          </b-card>
        </slide>
        <slide>
          <b-card @click="alterarDia(2)">
            <div class="indice">DIA 6</div>
            <div class="nome">quarta-feira</div>
            <div
              class="borda-carousel"
              v-bind:class="{ ativo: dias[2].estado }"
            ></div>
          </b-card>
        </slide>
        <slide>
          <b-card @click="alterarDia(3)">
            <div class="indice">DIA 7</div>
            <div class="nome">quinta-feira</div>
            <div
              class="borda-carousel"
              v-bind:class="{ ativo: dias[3].estado }"
            ></div>
          </b-card>
        </slide>
        <slide>
          <b-card @click="alterarDia(4)">
            <div class="indice">DIA 8</div>
            <div class="nome">sexta-feira</div>
            <div
              class="borda-carousel"
              v-bind:class="{ ativo: dias[4].estado }"
            ></div>
          </b-card>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      dias: [
        { nome: "segunda-feira", dia: "04", estado: false },
        { nome: "terça-feira", dia: "05", estado: false },
        { nome: "quarta-feira", dia: "06", estado: false },
        { nome: "quinta-feira", dia: "07", estado: false },
        { nome: "sexta-feira", dia: "08", estado: false },
      ],
    };
  },
  created() {
    let now = new Date();
    let hoje = now.getDate();
    switch (hoje) {
      case this.dias[0].dia:
        this.$emit("input", this.dias[0].dia);
        this.dias[0].estado = true;
        break;
      case this.dias[1].dia:
        this.$emit("input", this.dias[1].dia);
        this.dias[1].estado = true;
        break;
      case this.dias[2].dia:
        this.$emit("input", this.dias[2].dia);
        this.dias[2].estado = true;
        break;
      case this.dias[3].dia:
        this.$emit("input", this.dias[3].dia);
        this.dias[3].estado = true;
        break;
      case this.dias[4].dia:
        this.$emit("input", this.dias[4].dia);
        this.dias[4].estado = true;
        break;
      default:
        this.$emit("input", this.dias[0].dia);
        this.dias[0].estado = true;
        break;
    }
  },
  methods: {
    alterarDia(indice) {
      this.dias = this.dias.map((item, posicao) =>
        indice === posicao
          ? { ...item, estado: true }
          : { ...item, estado: false }
      );
      this.$emit("input", this.dias[indice].dia);
    },
  },
};
</script>

<style lang="scss" scoped>
.seletor {
  margin-left: 140px;
  margin-right: 140px;
}

.card {
  background-color: transparent;
  border: none;
  width: 158px;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding: 0px;
  width: 100% !important;
}
.cabecalho {
  width: 100%;
  display: flex;
  justify-content: center;
  .dias {
    display: flex;
    flex-direction: row;
    width: 100%;
    .dia {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin: 1rem;
      transition: border-width 0.6s linear;
      .indice {
        font-size: 1.25rem;
        font-weight: 400;
        text-align-last: center;
      }
      .nome {
        font-size: 1.2rem;
        font-weight: 300;
        text-align: center;
      }
      .borda {
        height: 2px;
        width: 100%;
        background-image: linear-gradient(to right, #2b195d, #7528c2, #d640f4);
        clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
        transition: clip-path 0.5s;
      }
      .ativo {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
      }
    }
  }
}
.indice {
  font-size: 1.25rem;
  font-weight: 400;
  text-align-last: center;
}
.nome {
  font-size: 1.2rem;
  font-weight: 300;
  text-align: center;
}
.borda-carousel {
  height: 2px;
  width: 100%;
  background-image: linear-gradient(to right, #2b195d, #7528c2, #d640f4);
  clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
  transition: clip-path 0.5s;
}
.ativo {
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
}

@media screen and (max-width: 1440px) {
  .seletor {
    margin-left: 100px;
    margin-right: 100px;
  }
  .card {
    width: 120px;
  }
}

@media screen and (max-width: 1108px) {
  .seletor {
    margin-left: 0px;
    margin-right: 0px;
  }
  .card {
    width: 120px;
  }
}
</style>
